import React from 'react';
import {Stack, Grid, Typography, Snackbar, Alert} from '@mui/material';

import ProgressIndicator from '../../../tsui/ProgressIndicator';

import * as Api from 'api/api';
import {ApiCard} from '../../../api';
import {PageButton} from '../../../tsui/Buttons/PageButton';
import {alertObject} from '../../../tsui/AlertObject';

interface Props {
    cardId: string;
    onChanged: () => void;
}

export default function CardDetailsBody(props: Props) {
    const [cardData, setCardData] = React.useState<ApiCard | null>(null);
    const [snackbarOpen, setSnackbarOpen] = React.useState(false);
    const [snackbarMessage, setSnackbarMessage] = React.useState('');

    React.useEffect(() => {
        Api.requestSession<ApiCard>('card', 'get', {cardId: props.cardId})
            .then((d) => {
                //console.log(d);
                setCardData(d);
            })
            .catch(alert);
    }, []);

    const onIssueCard = React.useCallback(() => {
        Api.requestSessionJson<any>('card', 'update', {cardId: props.cardId}, {issued: true})
            .then(processResult)
            .catch(alert);
    }, []);

    const onPrintBack = React.useCallback(() => {
        Api.requestSession<any>('printer', 'get_status', {side: 'back'})
            .then((d) => {
                if (d.status !== 0) {
                    alert(`Printer Status: ${d.status}`);
                    return;
                }

                Api.requestSession<any>('card', 'print', {cardId: props.cardId, side: 'back'})
                    .then(processResult)
                    .catch(alert);
            })
            .catch(alert);
    }, []);

    const onGenerateQr = React.useCallback(() => {
        Api.requestSession<any>('card', 'generate_qr', {cardId: props.cardId}).then(processResult).catch(alert);
    }, []);

    const onGeneratePage = React.useCallback(() => {
        Api.requestSession<any>('card', 'generate_page', {cardId: props.cardId}).then(processResult).catch(alert);
    }, []);

    const onGetPrinterStatus = React.useCallback(() => {
        Api.requestSession<any>('printer', 'get_status', {side: 'back'})
            .then((d) => {
                alert(`Status: ${d.status}`);
            })
            .catch(alert);
    }, []);

    const processResult = React.useCallback((response: any) => {
        props.onChanged();
        setSnackbarMessage(JSON.stringify(response));
        setSnackbarOpen(true);
    }, []);

    const handleSnackbarClose = React.useCallback(() => {
        setSnackbarOpen(false);
    }, [])

    if (!cardData) {
        return <ProgressIndicator />;
    }

    return (
        <Stack direction='row'>
            {/* <Stack direction='column' width='100%'>
                <Typography>{`Card: ${cardData.cardId}`}</Typography>
            </Stack> */}
            <Grid container width='100%' spacing={1}>
                <GridValue label='Id' value={cardData.cardId}/>
                <GridValue label='Type' value={cardData.cardType}/>
                <GridValue label='UserId' value={cardData.userId}/>

                <GridValue label='Issued' value={cardData.issued}/>
                <GridValue label='Printed' value={cardData.printed}/>
                <GridValue label='Activated' value={cardData.activated}/>

                {/* <Grid item xs={2}>Card Id:</Grid>
                <Grid item xs={2}>{cardData.cardId}</Grid> */}

            </Grid>

            <Stack direction='column' spacing={2} sx={{minWidth: 160}}>
                <PageButton label='Issue Card' onClick={onIssueCard} />
                <PageButton label='Print Back' onClick={onPrintBack} />
                <Typography>--Internal---</Typography>
                <PageButton label='Generate QR' onClick={onGenerateQr} />
                <PageButton label='Printer Status' onClick={onGetPrinterStatus} />
                <PageButton label='Generate Page' onClick={onGeneratePage} />
            </Stack>

            <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
                <Alert onClose={handleSnackbarClose} severity='success' sx={{width: '100%'}}>{snackbarMessage}</Alert>
            </Snackbar>
        </Stack>
    );
}

interface GridValueProps {
    label: string;
    value: string | number | boolean | undefined | null;
}

function GridValue(props: GridValueProps) {
    let value = typeof props.value === 'boolean' ? props.value ? 'YES' : 'NO' : props.value;
    return <>
        <Grid item xs={2}><Typography align='right' color='text.secondary'>{props.label}:</Typography></Grid>
        <Grid item xs={2}><Typography align='left' color='primary.main'>{value}</Typography></Grid>
    </>
}
